import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FcSearchManyInputModule } from '../../base/fc-search-many-input/fc-search-many-input.module';
import { FcRequestersInputComponent } from './fc-requesters-input.component';


@NgModule({
  declarations: [
    FcRequestersInputComponent
  ],
  imports: [
    FcSearchManyInputModule,
    TranslateModule
  ],
  exports: [
    FcRequestersInputComponent
  ]
})
export class FcRequestersInputModule {}
